import { object, string, array } from "yup";
import { OTHER_AGENCY_ID } from "./brandComplianceStaticData";

const validationSchema = object().shape({
  // About you
  name: string().required("You must enter your name"),
  email: string().email("Please enter a valid email").required("You must enter your email"),
  agencyId: string().required("You must select an agency"),
  // Conditional: free-text agency name when the "Other" agency is selected
  otherCreativeAgency: string().when("agencyId", {
    is: OTHER_AGENCY_ID,
    then: (schema) => schema.required("Please enter the name of your creative agency"),
  }),

  // About your submission
  isResubmission: string().required("Please indicate if this is a resubmission"),
  // TODO: confirm copy with PM — conditional: 7-digit reference number
  referenceNumber: string().when("isResubmission", {
    is: "Yes",
    then: (schema) =>
      schema
        .matches(/^\d{7}$/, "Please enter your 7-digit reference number")
        .required("Please enter your 7-digit reference number"),
  }),
  publicationType: array()
    .min(1, "You must indicate if this asset is for print, digital, or both")
    .required("You must indicate if this asset is for print, digital, or both"),
  submissionTitle: string().required("You must enter a submission title"),
  submissionSummary: string().required("You must enter a submission summary"),
  hasExceptions: string().required("Please indicate if this creative has exceptions"),
  // TODO: confirm copy with PM — conditional: exceptions summary
  exceptionsSummary: string().when("hasExceptions", {
    is: "Yes",
    then: (schema) => schema.required("Please describe the exceptions / permissions"),
  }),
  hasTechnicalLimitations: string().required("Please indicate if there are technical limitations"),
  // TODO: confirm copy with PM — conditional: technical limitations summary
  technicalLimitationsSummary: string().when("hasTechnicalLimitations", {
    is: "Yes",
    then: (schema) => schema.required("Please describe the technical limitations"),
  }),
  hasCoBranding: string().required("Please indicate if this creative features co-branding"),
  // TODO: confirm copy with PM — conditional: legal agreement (co-branding = Yes)
  hasLegalAgreement: string().when("hasCoBranding", {
    is: "Yes",
    then: (schema) => schema.required("Please indicate if there is a legal agreement in place"),
  }),
  // TODO: confirm copy with PM — conditional: brand identity (co-branding = Yes)
  isBrandIdentity: string().when("hasCoBranding", {
    is: "Yes",
    then: (schema) => schema.required("Please indicate if this creative is in Verizon's brand identity"),
  }),
  hasAiImagery: string().required("Please indicate if this creative features AI-generated imagery"),
  businessAreaId: string().required("You must select a Verizon business area"),
  functionalAreaId: string().required("You must select a Verizon functional area"),
  verizonClientName: string().required("You must enter the Verizon client name"),
  verizonDirectorName: string().required("You must enter the Verizon director name"),
  verizonVpName: string().required("You must enter the Verizon VP name"),

  // Files
  files: array()
    .min(1, "Please upload your creative asset(s)")
    .required("Please upload your creative asset(s)"),
  fileAssetTypes: object().test(
    "asset-type-per-file",
    "You must select an asset type for each file",
    function (value) {
      const files: File[] = this.parent.files ?? [];
      return files.every((f) => !!(value as Record<string, string>)?.[f.name]);
    }
  ),
});

export default () => validationSchema;
